import { render, staticRenderFns } from "./SearchLocation.vue?vue&type=template&id=b2ee72c8&"
import script from "./SearchLocation.vue?vue&type=script&lang=js&"
export * from "./SearchLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SearchLocation.vue"
export default component.exports